export const deepMerge = (target, source) => {
	for (const key in source) {
		if (source[key] instanceof Object && key in target) {
			Object.assign(source[key], deepMerge(target[key], source[key]));
		}
	}
	return { ...target, ...source };
};

export const isObjectEmpty = (obj) => JSON.stringify(obj) === "{}";